import { toast } from 'sonner'
import { Printer, CreditCard, DollarSign } from 'lucide-react'
import type { TFunction } from 'i18next'

export function toastPrinterSuccess(t: TFunction) {
  toast.success(t('hardware.printerSuccess'), {
    icon: <Printer className="h-5 w-5" />,
    duration: 3000,
  })
}

export function toastPrinterError(t: TFunction) {
  toast.error(t('hardware.printerError'), {
    icon: <Printer className="h-5 w-5" />,
    duration: 8000,
  })
}

export function toastPaymentReceived(t: TFunction) {
  toast.success(t('hardware.paymentReceived'), {
    icon: <CreditCard className="h-5 w-5" />,
    duration: 4000,
  })
}

export function toastDrawerOpened(t: TFunction) {
  toast.info(t('hardware.drawerOpened'), {
    icon: <DollarSign className="h-5 w-5" />,
    duration: 2000,
  })
}
